"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var VerificationCodeInput =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(VerificationCodeInput, _Backbone$View);

  _createClass(VerificationCodeInput, [{
    key: "template",
    value: function template(_ref) {
      var className = _ref.className,
          id = _ref.id,
          codeLength = _ref.codeLength,
          label = _ref.label;
      var inputLabelBoxes = $('<div></div>');
      inputLabelBoxes.append('<div class="inputLabelBoxes"></div>');

      for (var i = 0; i < codeLength; i++) {
        inputLabelBoxes.find('.inputLabelBoxes').append("\n                <div class=\"inputLabelBox\" style=\"width: ".concat(this.boxWidthPercentage, "%\" id=\"").concat(i, "\"><div>\n            "));
      }

      return "\n            <div class=\"verificationCodeInput ".concat(className, "\" style=\"padding-top: ").concat(this.containerHeightPercentage, "%\">\n                <input id=\"").concat(id, "\" type=\"tel\" name=\"").concat(id, "\" aria-label=\"").concat(label, "\">\n                ").concat(inputLabelBoxes.html(), "\n            </div>");
    }
  }]);

  function VerificationCodeInput(_ref2) {
    var _this;

    var className = _ref2.className,
        id = _ref2.id,
        codeLength = _ref2.codeLength,
        label = _ref2.label;

    _classCallCheck(this, VerificationCodeInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VerificationCodeInput).apply(this, arguments));

    _.extend(_assertThisInitialized(_this), arguments[0]);

    _this.codeLength = codeLength || 6;
    return _this;
  }

  _createClass(VerificationCodeInput, [{
    key: "render",
    value: function render() {
      this.boxWidthPercentage = Math.floor(100 / this.codeLength - 1);
      this.containerHeightPercentage = Math.round(this.boxWidthPercentage * 4 / 3);
      this.$el.empty().append(this.template(this));
      this.$input = this.$el.find('input');

      this._attachEvents();

      return this;
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this2 = this;

      this.$input.on('input change', function () {
        var inputCode = _this2.$input.val().replace(/\D/g, '');

        if (inputCode.length > _this2.codeLength) {
          inputCode = inputCode.slice(0, _this2.codeLength);
        }

        _this2.$input.val(inputCode);

        for (var i = 0; i < _this2.codeLength; i++) {
          var box = _this2.$el.find(".inputLabelBox#".concat(i));

          box.empty().append("<div class=\"inputBoxContentWrapper\"><span class=\"inputBoxContents\">".concat(inputCode.charAt(i), "</span></div>"));

          if (i < inputCode.length) {
            box.removeClass('focused');
          } else if (i === inputCode.length) {
            box.addClass('filled').addClass('focused');
          } else {
            box.removeClass('filled').removeClass('focused');
          }
        }

        if (inputCode.length === _this2.codeLength) {
          _this2.$el.find(".inputLabelBox#".concat(inputCode.length - 1)).addClass('focused');
        }
      });
      this.$el.find('.inputLabelBox').on('click', function () {
        _this2.$input.focus();
      });
      this.$input.on('focus', function () {
        var index = _this2.$input.val().length;

        if (index === _this2.codeLength) {
          index--;
        }

        _this2.$el.find(".inputLabelBox#".concat(index)).addClass('focused').addClass('filled');
      });
      this.$input.on('blur', function () {
        var index = _this2.$input.val().length;

        if (index === _this2.codeLength) {
          _this2.$el.find(".inputLabelBox#".concat(index - 1)).removeClass('focused');
        } else {
          _this2.$el.find(".inputLabelBox#".concat(index)).removeClass('focused').removeClass('filled');
        }
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$input.focus();
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;

      if (this.$input.val().length === this.codeLength) {
        return true;
      }

      this.$el.find('.verificationCodeInput').addClass('invalid');
      this.$input.on('focus', function () {
        _this3.$el.find('.verificationCodeInput').removeClass('invalid');
      });
    }
  }]);

  return VerificationCodeInput;
}(Backbone.View);

exports["default"] = VerificationCodeInput;